import { FiPhone, FiMail } from "react-icons/fi";
import { FaFacebookF, FaInstagram, FaTwitter, FaWhatsapp } from "react-icons/fa";
import "../assets/css/custom-style.css";

export default function TopBar() {


    return (
        <div className="bg-gray-900 dark:bg-sky-100 text-gray-300 dark:text-gray-800 text-sm">
            <div className="container mx-auto px-6 py-2 flex items-center justify-between">

                {/* LEFT */}
                <div className="flex items-center gap-6 max-[500px]:flex-col max-[500px]:items-start max-[500px]:gap-2">

                    <a
                        href="tel:+971501234567"
                        className="flex items-center gap-2 hover:text-white dark:hover:text-sky-600 transition-colors"
                    >
                        <FiPhone size={14} />
                        +971 50 123 4567
                    </a>

                    <a
                        href="mailto:info@southtravels.com"
                        className="flex items-center gap-2 hover:text-white dark:hover:text-sky-600 transition-colors"
                    >
                        <FiMail size={14} />
                        info@southtravels.com
                    </a>

                </div>

                {/* RIGHT */}
                <div className="flex items-center gap-4">
                    {/* Facebook */}
                    <a
                        href="https://www.facebook.com/SouthTravelsUAE/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Facebook"
                    >
                        <FaFacebookF />
                    </a>

                    {/* Instagram */}
                    <a
                        href="https://www.instagram.com/southtravels8376/"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Instagram"
                    >
                        <FaInstagram />
                    </a>

                    {/* Twitter / X */}
                    <a
                        href="https://twitter.com/SouthTravels"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Twitter"
                    >
                        <FaTwitter />
                    </a>

                    {/* WhatsApp */}
                    <a
                        href="https://api.whatsapp.com/send?phone=971502477593&text=Hi%2C%20I%20would%20like%20to%20inquire%20about%20something.%20I%20found%20your%20website%20at%20https%3A%2F%2Fwww.southtravels.com%2F"
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label="WhatsApp"
                    >
                        <FaWhatsapp />
                    </a>
                </div>

            </div>
        </div>
    );
}